var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddStaffGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 248.453,
    viewBox: "0 0 240 248.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects",
    transform: "translate(-11.651 -7.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(11.651 7.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M269.452,89.853a.85.85,0,0,0,.166-.015c1.9,24.187,24.927,46.847,45.76,46.847,20.44,0,43.826-22.661,45.76-46.847a1.1,1.1,0,0,0,.181.015,8.021,8.021,0,0,0,8.007-8.007c0-5.529,2.13-9.533,2.13-14.05a9.478,9.478,0,0,0-9.472-9.472q-.363,0-.725.03s.347-3.777.347-7.357c0-26.966-17.207-43.3-42.466-43.3h-7.508c-25.274,0-42.466,16.331-42.466,43.3,0,3.58.332,7.357.332,7.357q-.347-.03-.71-.03A9.481,9.481,0,0,0,259.3,67.8c0,4.517,2.145,8.52,2.145,14.05A8.011,8.011,0,0,0,269.452,89.853Z",
    transform: "translate(-221.887 -7.7)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M251.651,900.87a54.886,54.886,0,0,1-93.695,38.81,55.266,55.266,0,0,1-8.732-11.361,287.156,287.156,0,0,1-44.083,3.052c-40.291,0-65.792-6.179-80.582-13.778A23.752,23.752,0,0,1,13.2,888.044c4.185-11,10.62-24.64,19.1-33.1,13.491-13.476,31.559-21.014,37.058-23.1,10.756,10.258,23.7,16.1,35.789,16.1,11.965,0,24.866-5.862,35.668-16.15,4.789,1.813,20.047,8.1,32.949,19.216a54.9,54.9,0,0,1,77.893,49.854Zm-9.125,0a45.76,45.76,0,1,0-45.76,45.76A45.8,45.8,0,0,0,242.526,900.87Z",
    transform: "translate(-11.651 -707.302)",
    fill: "#c1c1c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M1111.636,1137.334h-18.552v-18.552a3.883,3.883,0,1,0-7.765,0v18.552h-18.536a3.875,3.875,0,1,0,0,7.75h18.536v18.552a3.883,3.883,0,1,0,7.765,0v-18.552h18.552a3.875,3.875,0,0,0,0-7.75Z",
    transform: "translate(-904.086 -947.633)",
    fill: "#c1c1c1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStaffGrey);
export default __webpack_public_path__ + "static/media/add-staff-grey.8372f8667c4f7199d769fc0821d29d6e.svg";
export { ForwardRef as ReactComponent };